export const BEGIN_DOCUMENT_UPLOAD = '@@od/store/agentResaleOfferPortal/beginDocumentUpload';
export const DELETE_DOCUMENT = '@@od/store/agentResaleOfferPortal/deletedocument';
export const DOCUMENT_UPLOAD_SUCCESS = '@@od/store/agentResaleOfferPortal/documentUploadSuccess';
export const ERROR_AGENT = '@@od/store/agentResaleOfferPortal/errorAgent';
export const ERROR_LISTING = '@@od/store/agentResaleOfferPortal/errorListing';
export const ERROR_LISTING_OFFER = '@@od/store/agentResaleOfferPortal/errorListingOffer';
export const ERROR_ON_DOCUMENT_UPLOAD = '@@od/store/agentResaleOfferPortal/errorOnDocumentUpload';
export const ERROR_ON_GET_DOCUMENT_UPLOAD_URL =
  '@@od/store/agentResaleOfferPortal/errorOnGetDocumentUploadUrl';
export const GET_DOCUMENT_UPLOAD_URL = '@@od/store/agentResaleOfferPortal/getDocumentUploadUrl';
export const GET_AGENT = '@@od/store/agentResaleOfferPortal/getAgent';
export const SET_AGENT = '@@od/store/agentResaleOfferPortal/setAgent';
export const GET_LISTING = '@@od/store/agentResaleOfferPortal/getListing';
export const SET_LISTING = '@@od/store/agentResaleOfferPortal/setListing';
export const SET_LISTING_OFFER = '@@od/store/agentResaleOfferPortal/setListingOffer';
export const SET_TYPED_AGENT_EMAIL = '@@od/store/agentResaleOfferPortal/setTypedAgentEmail';
export const SET_TYPED_AGENT_FULL_NAME = '@@od/store/agentResaleOfferPortal/setTypedAgentFullName';
export const SET_TYPED_AGENT_PHONE_NUMBER =
  '@@od/store/agentResaleOfferPortal/setTypedAgentPhoneNumber';
export const SUBMIT_LISTING_OFFER = '@@od/store/agentResaleOfferPortal/submitListingOffer';
export const SET_OFFER_SUBMISSION_COMPLETED =
  '@@od/store/agentResaleOfferPortal/setOfferSubmissionCompleted';
export const UPLOAD_DOCUMENT = '@@od/store/agentResaleOfferPortal/uploadDocument';
